module.exports = __webpack_public_path__ + "img/setup_icon_jiang.5e5619fd.png";